import { useEffect, type RefObject } from "react";

export function useScrollToResults(queryParams: string | null, containerRef: RefObject<HTMLDivElement | null>) {
    useEffect(() => {
        if (queryParams && containerRef.current) {
            const desiredTop = containerRef.current.offsetTop - 64;
            const maxScrollTop = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
            const top = Math.min(desiredTop, maxScrollTop);
            window.scrollTo({ top, behavior: "smooth" });
        }
    }, [queryParams, containerRef]);
}
